<template>
  <div class="d-flex-column justify-start gap-9 dungeon_picker">
    <div class="d-flex-row dungeon_image_container">
      <img :src="dungeon?.image" alt="dungeon image" class="dungeon_image" />
    </div>
    <h6 class="t-light medium-m font-family-2">{{ dungeon?.title }}</h6>
    <ValueSetter
      :min="0"
      :max="minNumberOfDungeons"
      v-model="numberOfDungeons"
    />
  </div>
</template>
<script>
import ValueSetter from "../../commonpickers/ValueSetter.vue";
export default {
  data() {
    return {
      numberOfDungeons: 0,
    };
  },
  computed: {
    minNumberOfDungeons() {
      if (this.checkoutStore.getDetails?.numberOfMythic > 0) {
        let remainingDungeon =
          this.checkoutStore.getDetails?.numberOfMythic -
          this.alreadySelectedDungeonsCount;

        return remainingDungeon + this.numberOfDungeons;
      }
      return 0;
    },
    alreadySelectedDungeonsCount() {
      if (this.checkoutStore.getSelectedDungeons.length > 0) {
        let count = 0;
        this.checkoutStore.getSelectedDungeons?.forEach(
          (dungeon) => (count += dungeon.numberOfDungeons)
        );
        return count;
      }
      return 0;
    },
  },

  props: {
    dungeon: {
      default: {},
    },
  },
  methods: {
    includesDungeon(dungeonId) {
      if (this.checkoutStore.getSelectedDungeons.length > 0) {
        const dungeon = this.checkoutStore.getSelectedDungeons.find(
          (dungeon) => dungeon.id === dungeonId
        );
        if (dungeon) {
          return true;
        }
      }
      return false;
    },
  },
  components: {
    ValueSetter,
  },
  watch: {
    numberOfDungeons() {
      if (this.numberOfDungeons > 0) {
        const otherDungeons = this.checkoutStore.getSelectedDungeons?.filter(
          (dungeonE) => dungeonE.id !== this.dungeon.id
        );
        this.checkoutStore.setDungeons([
          ...otherDungeons,
          {
            id: this.dungeon.id,
            title: this.dungeon.title,
            numberOfDungeons: this.numberOfDungeons,
          },
        ]);
      } else if (this.numberOfDungeons <= 0) {
        const otherDungeons = this.checkoutStore.getSelectedDungeons?.filter(
          (dungeonE) => dungeonE.id !== this.dungeon.id
        );
        this.checkoutStore.setAllDungeons(otherDungeons);
      }
    },
    "checkoutStore.getDetails.numberOfMythic"() {
      this.numberOfDungeons = 0;
      this.checkoutStore.setAllDungeons([]);
    },
  },
  setup() {
    const checkoutStore = useCheckoutStore();

    return {
      checkoutStore,
    };
  },
};
</script>
